import { IsoDateStr } from '@moment/domain-types'
import { Temporal } from 'temporal-polyfill'

/**
 * Today's calendar date, in the viewer's own zone unless `timeZone` says
 * otherwise — the day someone means when they read "today" on screen.
 *
 * Pass a zone explicitly (e.g. {@link DEFAULT_TIME_ZONE}) where the day has to
 * match data stamped in that zone rather than the one the viewer sits in.
 */
export function todayIsoDate(timeZone?: string): IsoDateStr {
  return IsoDateStr.parse(Temporal.Now.plainDateISO(timeZone).toString())
}
